export const Constants = {
  TAG_NAME: 'pop-pc-documents-table-component',
  TRANSLATION_KEYS: {
    PRODUCT_DISCLOSURE_STATEMENT:
      'tables.documents.headers.product_disclosure_statement',
    TARGET_MARKET_DETERMINATION:
      'tables.documents.headers.target_market_determination',
    PERFORMANCE_REPORT: 'tables.documents.headers.performance_report',
    PRODUCT_PROFILE: 'tables.documents.headers.product_profile',
    QUARTERLY_REVIEW: 'tables.documents.headers.quarterly_review',
  },
  DOCUMENTS_COLUMN_IDS: {
    PRODUCT_DISCLOSURE_STATEMENT: 'product-disclosure-statement',
    TARGET_MARKET_DETERMINATION: 'target-market-determination',
    PERFORMANCE_REPORT: 'perfomance-report',
    PRODUCT_PROFILE: 'product-profile',
    QUARTERLY_REVIEW: 'quarterly-review',
  },
  REPORT_ROW_CLASS: 'b-flex b-justify-center',
} as const;
